import React from 'react';
import { FaArrowRight, FaMapMarkerAlt } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import '../css/walkingHikingTours.css'; // Import custom styles
import NavBar from './nav';
import Footer from './footer';
import { findJourneyItem } from './journeyData';

const NationalParks = () => {
  const navigate = useNavigate();
  // List of national parks around Kimberley
  const nationalParks = [
    {
      slug: "mokala-national-park",
      name: "Mokala National Park",
      description: "Mokala National Park is known for its diverse landscapes, including savannahs, rocky hills, and riverine forests. It's a haven for wildlife enthusiasts, offering sightings of rare species like the roan antelope and black rhino.",
      image: require("../assets/mokala-national-park-entrance-sign-01-500x300.jpg"),
    },
    {
      slug: "augrabies-falls-national-park",
      name: "Augrabies Falls National Park",
      description: "Located a few hours from Kimberley, Augrabies Falls National Park is famous for its stunning waterfall and rugged landscapes. The park offers hiking trails with breathtaking views of the Orange River Gorge.",
      image: require("../assets/images (6).jfif"), // Replace with actual image path
    },
    
    {
      slug: "richtersveld-national-park",
      name: "Richtersveld National Park",
      description: "Richtersveld National Park is a UNESCO World Heritage Site known for its dramatic desert landscapes, unique flora, and the meandering Orange River. It's a paradise for hikers and nature lovers.",
      image: require("../assets/richtersveld_national_park_landscape.jpg"), // Replace with actual image path
    }
  ];

  const openDetails = (park) => {
    const item = findJourneyItem(park.slug);
    navigate(`/journey/${park.slug}`, { state: { item } });
  };

  return (
    <div>
      <NavBar />
      
      {/* Hero Section */}
      <div className="hero-section">
        <h1 className="hero-title">Discover National Parks Near Kimberley</h1>
        <p className="hero-subtitle">Explore the natural beauty and wildlife of these stunning parks.</p>
      </div>

      {/* National Parks Section */}
      <div className="walking-hiking-tours">
        <h1 className="section-title">National Parks Around Kimberley</h1>
        <p className="section-subtitle">From desert landscapes to lush riverine forests, these parks offer unforgettable experiences.</p>
        
        <div className="hiking-spots-grid">
          {nationalParks.map((park, index) => (
            <div key={index} className="hiking-spot-card">
              <div className="hiking-spot-image-container">
                <img src={park.image} alt={park.name} className="hiking-spot-image" />
                <span className="hiking-card-chip">
                  <FaMapMarkerAlt /> Northern Cape
                </span>
              </div>
              <div className="hiking-spot-content">
                <span className="hiking-card-kicker">Park {index + 1}</span>
                <h2 className="hiking-spot-name">{park.name}</h2>
                <p className="hiking-spot-description">{park.description}</p>
                <button type="button" className="visit-button" onClick={() => openDetails(park)}>
                  Learn More <FaArrowRight />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default NationalParks;
